<!-- #84 -->
<template>
  <v-col class="mx-4">
    <div class="d-flex">
      <div
        class="text-h6 py-0 my-0 pl-0"
        style="color: #23468c; font-weight: 500"
      >
        Country Coverage
      </div>
      <v-spacer></v-spacer>
      <router-link
        class="text-decoration-none"
        :to="{ name: 'CarrierCoverage' }"
      >
        <v-btn color="primary" class="mr-2" small :loading="countriesLoader"
          >Carrier Coverage</v-btn
        >
      </router-link>
    </div>
    <v-divider class="mt-1 mb-4"></v-divider>
    <v-data-table
      :headers="headers"
      :items="countriesCoverage"
      :options.sync="options"
      :server-items-length="total"
      :loading="countriesLoader"
      :items-per-page="25"
      class="elevation-1 mt-7"
      :footer-props="{
        itemsPerPageOptions: [25, 50, 100, 250],
        showFirstLastPage: true,
        firstIcon: 'mdi-arrow-collapse-left',
        lastIcon: 'mdi-arrow-collapse-right',
        prevIcon: 'mdi-minus',
        nextIcon: 'mdi-plus',
      }"
    >
      <template v-slot:top>
        <v-row>
          <v-col cols="12" md="12" sm="12" xs="12" class="pt-0">
            <Search
              :search-options="searchOptions"
              @changeText="(res) => (search = res)"
            />
          </v-col>
        </v-row>
        <v-divider class="mb-2"></v-divider>
      </template>
      <template v-slot:[`item.partner`]="{ item }">
        <p class="ma-1" v-for="(s, i) in item.partner" :key="i">
          {{ s }}
        </p>
      </template>
      <template v-slot:[`item.client`]="{ item }">
        <p class="ma-1" v-for="(s, i) in item.client" :key="i">
          {{ s }}
        </p>
      </template>
    </v-data-table>
  </v-col>
</template>
<script>
import { mapActions } from "vuex";
import Search from "@/components/front/common/Search";

export default {
  components: {
    Search,
  },

  data: () => ({
    search: "",
    searchOptions: [
      {
        text: "Country Coverage",
        value: "country_name",
      },
    ],
    headers: [
      {
        text: "Country Coverage",
        value: "country_name",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Partner",
        value: "partner",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Client",
        value: "client",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
    ],
    countriesCoverage: [],
    options: {},
    countriesLoader: false,
    total: 0,
  }),

  watch: {
    options: {
      handler() {
        this.fetchCountryWiseCoverage();
      },
      deep: true,
    },
    search() {
      this.fetchCountryWiseCoverage();
    },
  },

  methods: {
    ...mapActions(["getCountrywiseCoverage"]),

    fetchCountryWiseCoverage() {
      this.countriesCoverage = [];
      this.countriesLoader = true;
      const payload = new FormData();
      payload.append("country", this.search);

      this.getCountrywiseCoverage({ payload, ...this.options })
        .then((res) => {
          this.countriesLoader = false;
          this.countriesCoverage = res.data.records;
          this.total = res.data.total;
        })
        .catch(() => {
          this.countriesLoader = false;
        });
    },
  },
};
</script>
